import React from 'react';
import PropTypes from 'prop-types';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import Email from 'services/data/email';

// Components
import SVG from 'components/widgets/icons/svg';
import ActionCompleteIndicator from 'components/widgets/state-indicators/complete-indicator';
import { actions as modalActions } from 'modules/modals/actions';
import { RoundLoader } from 'components/widgets/state-indicators/loader';


export default class SendToInboxOption extends React.Component {
  static propTypes = {
    emailId: PropTypes.number,
    currentUser: PropTypes.object
  };

  constructor() {
    super();
    this.state = {};
    this.sendToInbox = this.sendToInbox.bind(this);
    this.confirmSendToInbox = this.confirmSendToInbox.bind(this);
  }

  confirmSendToInbox() {
    modalActions.showDeleteModal({
      onConfirm: this.sendToInbox,
      title: 'Make sure this is not a Mailgun phishing email!',
      body: 'This email has the word Mailgun in it, if its a phishing email Mailgun could lock our account for sending a Mailgun phishing email through their service, please triple check before sending it to your inbox.'
    });
  }

  sendToInbox() {
    const { emailId, currentUser } = this.props;
    this.setState({ sendingToInbox: true, sentToInbox: false });

    Email.sendToInbox(emailId, currentUser.id)
      .then(() => {
        this.setState({ sendingToInbox: false, sentToInbox: true });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { confirm } = this.props;
    const { sendingToInbox, sentToInbox } = this.state;

    return (
      <li className="triage-option-deliver triage-option-header" onClick={confirm ? this.confirmSendToInbox : this.sendToInbox}>
        <SVG src="svg/send-to-inbox.svg" className="triage-option-icon send-to-inbox" />
        Send to Inbox
        <span>
          { (sendingToInbox && !sentToInbox) &&
            <RoundLoader className="margin-left" color={'#ddd'} />
          }
          { (sentToInbox && !sendingToInbox) &&
            <ActionCompleteIndicator className="margin-left" />
          }
        </span>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/send-to-inbox.js